/** @format */
import { css } from 'styled-components';

import { Market, MarketCode } from '@toucan/client/global/market';

/**
 * Gets the CSS `transform` property for the basket plus
 */
export const getBasketPlusTransform = (activeMarket: Market) => {
    return activeMarket.code === MarketCode.EN_US
        ? css`
              transform: scale(0.5) translate(70%, -70%);
          `
        : css`
              transform: scale(0.5) translate(70%, 80%);
          `;
};
